import { adminAccessFeature } from "@/features/admin-access";
import { aiAssessmentFeature } from "@/features/ai-assessment";
import { clientMomentumFeature } from "@/features/client-momentum";
import { completedTasksFeature } from "@/features/completed-tasks";
import { emailFeature } from "@/features/email";
import { overviewFeature } from "@/features/overview";
import { siteMonitorFeature } from "@/features/site-monitor";
import { timesheetFeature } from "@/features/timesheet";
import { toolsFeature } from "@/features/tools";
import type { FeatureModule } from "@/types/feature";

/**
 * The feature registry. Adding a feature = build its folder, export a
 * FeatureModule, and add it to this array. The router and sidebar are derived
 * from this list, so nothing else in the shell needs editing.
 */
export const FEATURES: readonly FeatureModule[] = [
  overviewFeature,
  clientMomentumFeature,
  completedTasksFeature,
  aiAssessmentFeature,
  timesheetFeature,
  emailFeature,
  siteMonitorFeature,
  toolsFeature,
  adminAccessFeature,
];
